<template>
  <div class="product">
    <template v-if="photo">
      <div class="product__image product-image-bg"  v-bind:style="{ 'background-image': 'url(' + getPhotoUrl + ')' }" >
      </div>
    </template>
    <template v-else>
      <div class="product__image" style="margin-top: 20px; margin-bottom: 20px">
        <img
            src="../../../assets/images/products/book.png"
            width="156"
            v-if="productType === 'book'"
        />
        <img
            src="../../../assets/images/products/e-book.png"
            width="128"
            v-else-if="productType === 'e-book'"
        />
        <div v-else style="color: grey;">No photo available</div>
      </div>
    </template>
    <div class="product__text-wrapper">
      <h3 class="product__title">{{ name }}</h3>
      <h4 class="product__price">
        {{ displayPrice }}
      </h4>
      <div class="product__delivery">
        <el-icon name="box mr-1"></el-icon>
        {{ strAvailableDeliveryMethods }}
      </div>
      <template v-if="isAcceptingOrders">
        <template v-if="_isOutOfStock === false">
          <el-button @click="_clickOnAddToCart()" type="primary">
            <el-icon
              name="shopping-cart-2 mr-2"
              style="font-size:14px"
            ></el-icon
            >Add To Cart
          </el-button>
        </template>
        <template v-else>
          <div class="ui grey label">
            <el-icon name="sold-out mr-2"></el-icon>Out of stock
          </div>
        </template>
      </template>
      <template v-else>
        <div class="ui grey label">No longer for sale</div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { get } from 'lodash';
export default {
  data() {
    return {};
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    photo: {
      required: false
    },
    productType: {
      type: String,
      required: true
    },
    displayPrice: {
      type: String,
      require: true
    },
    displayStock: {
      type: [Number, String],
      require: true
    },
    isOutOfStock: {
      type: Boolean,
      require: true
    },
    isStockTracked: {
      type: Boolean,
      require: true
    },
    isAcceptingOrders: {
      type: Boolean,
      require: true
    },
    isShippable: {
      type: Boolean,
      require: true
    },
    isForPickup: {
      type: Boolean,
      require: true
    }
  },
  methods: {
    ...mapActions(["addItemToCart"]),
    _clickOnAddToCart() {
      this.addItemToCart(this.id);
    }
  },
  computed: {
    ...mapGetters(["isProductOutOfStock"]),
    _isOutOfStock() {
      return this.isProductOutOfStock(this.id);
    },
    strAvailableDeliveryMethods() {
      if (this.isShippable && !this.isForPickup) {
        return "Shipped";
      } else if (this.isShippable && this.isForPickup) {
        return "Shipped or school pickup";
      } else if (!this.isShippable && this.isForPickup) {
        return "School pickup";
      } else {
        return "";
      }
    },
    getPhotoUrl() {
      if (this.photo) {
        return get(this.photo, 'reses.300') || get(this.photo, 'reses.150') || get(this.photo, 'thumb');
      }
    }
  }
};
</script>
<style>
.product-image-bg {
  background-size: contain;
  background-position: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
